import { createContext, useContext } from "react";

/**
 * True below a provider that hasn't mounted its overlays yet: a `Tooltip` or
 * `Menu.Root` there renders its trigger alone, the same element without its
 * Base UI root, so a list of many items skips their roots until one is
 * reached. A `Menu.Trigger` trigger renders its `render` element without the
 * trigger's behavior. Overlays mount when the value turns false.
 */
export const OverlayDeferralContext = createContext(false);

export const useIsOverlayDeferred = () => useContext(OverlayDeferralContext);
